<template>
  <div class="w-full">
    <!-- Name -->
    <text-input
      v-if="localItem.name != undefined"
      label="Name"
      id="name"
      class="w-full sm:w-2/3"
      :error="!localItem.nameIsValid"
      :value.sync="localItem.name"
    />
    <div class="flex flex-row w-full">
      <!-- Category -->
      <dropdown-input
        v-if="localItem.category != undefined"
        :value.sync="localItem.category"
        :options="categories"
        :error="!localItem.categoryIsValid"
        class="w-1/2 pr-5 sm:w-1/3"
        label="Category"
        id="category"
      />
      <!-- Subcategory -->
      <dropdown-input
        v-if="localItem.category != undefined && subcategories[localItem.category] != undefined"
        :value.sync="localItem.subCategory"
        :options="subCategoryOptions"
        :error="!localItem.subcategoryIsValid"
        class="w-1/2 sm:w-1/3"
        label="Subcategory"
        id="subcategory"
      />
    </div>
    <!-- Description -->
    <div class="w-full py-2">
      <label class="block pr-4 text-lg font-medium" for="description">Description</label>
      <textarea
        v-model="localItem.description"
        :class="{ 'border-red-500': !localItem.descriptionIsValid }"
        class="w-full p-2 border rounded outline-none focus:outline-none"
        id="description"
        type="text"
        rows="7"
      />
    </div>
    <!-- Image list -->
    <item-images
      v-if="!disabled && localItem.images != undefined"
      :images.sync="localItem.images"
      :disabled="disabled"
      :filesIsValid="localItem.filesIsValid"
    />
  </div>
</template>

<script>
import data from '../../assets/json/data.json';
import TextInput from './TextInput.vue';
import DropdownInput from './DropdownInput.vue';
import ItemImages from './ItemImages.vue';

export default {
  name: 'item-display',
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    DropdownInput,
    ItemImages,
    TextInput,
  },
  data() {
    return {
      localItem: this.item,
      categories: data.categories,
      subcategories: data.subcategories,
    };
  },
  computed: {
    subCategoryOptions() {
      return this.subcategories[this.localItem.category].map((option) => option.name);
    },
  },
  watch: {
    localItem: {
      handler(val) {
        if (val.name.length > 0) this.localItem.nameIsValid = true;
        if (val.category.length > 0) this.localItem.categoryIsValid = true;
        if (val.subCategory.length > 0) this.localItem.subcategoryIsValid = true;
        if (val.description.length > 0) this.localItem.descriptionIsValid = true;
        if (val.images.length > 0) this.localItem.filesIsValid = true;
        this.$emit('update:item', this.localItem);
      },

      deep: true,
    },
    item: {
      handler(val) {
        if (val != this.localItem) {
          this.localItem = val;
        }
      },
      deep: true,
    },
  },
};
</script>
